<template>
  <v-navigation-drawer
      class="mt-12 pb-7 nav-drawer" :mini-variant-width="$vuetify.breakpoint.mobile ? 0 : 56"
      app
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      :expand-on-hover="!$vuetify.breakpoint.mobile"
  >
    <perfect-scrollbar>
      <v-list>
        <v-list-item
            color="#3A3852"
            class="item_menu"
            to="/"
        >
          <v-list-item-icon :class="`color-${menuItems.overview}`">
            <v-icon :class="`mr-3 fal fa-home`"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Overview'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
                color="#3A3852"
                class="item_menu"
                to="/payment-methods"
        >
          <v-list-item-icon :class="`color-${menuItems.overview}`">
            <v-icon :class="`mr-3 fal fa-credit-card`"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Payment Methods'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
            :value="true"
        >
          <template v-slot:activator>
            <v-list-item-icon :class="`color-${menuItems.payments}`">
              <v-icon :class="`mr-3 fal fa-money-check-alt`"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Payments'"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              to="/payments/active"
          >
            <v-list-item-icon :class="`color-${menuItems.payments}`">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Active'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              to="/payments/pending"
          >
            <v-list-item-icon :class="`color-${menuItems.payments}`">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Pending'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              to="/payments/approved"
          >
            <v-list-item-icon :class="`color-${menuItems.payments}`">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Approved'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              to="/payments/closed"
          >
            <v-list-item-icon :class="`color-${menuItems.payments}`">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Paid'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              to="/payments/carried-over"
          >
            <v-list-item-icon :class="`color-${menuItems.payments}`">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Carried Over'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import store from "@/store";
import {mapState} from "vuex";

export default {
  props: ['value'],
  name: "Navigation",
  data() {
    return {
      mini: true,
      drawer: false,
      tempColor: 'secondary',
      overviewColor: this.$vuetify.theme.themes.light.secondary,
    }
  },
  methods: {
  },
  computed: {
    ...mapState('user', ['user']),
    menuItems() {
      const menuItems = {
        overview: 'secondary',
        payments: 'secondary',
      };
      if (this.$route.path === '/') {
        menuItems['overview'] = 'primary';
      }
      if (this.$route.path.includes('/payments')) {
        menuItems['payments'] = 'primary';
      }

      return menuItems;
    }
  },
  watch: {
    value() {
      this.mini = this.value
    },
    mini() {
      this.$emit('input', this.mini)
    }
  },
}
</script>

<style scoped>

</style>
